import React from 'react';

export default function MaxWidth({ width, children }) {
	return <div style={{ maxWidth: width, width: '100%' }}>
		{children}
	</div>;
}
